import clevertap from "clevertap-web-sdk";

export function getLatLong() {
	try {
		return new Promise((resolve, reject) => {
			if (!navigator.geolocation) {
				reject(new Error("Geolocation is not supported by this browser."));
			} else {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const { latitude, longitude } = position.coords;

						// Send to CleverTap
						// if (typeof clevertap !== "undefined" && clevertap.getLocation) {
						clevertap.getLocation(latitude, longitude);
						// }

						resolve({ latitude, longitude });
					},
					(error) => {
						reject(error);
					},
				);
			}
		});
	} catch (err) {
		return {};
	}
}
